import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { App } from './App';
import { HomePage } from './components/HomePage';
import { MineralsApp } from './components/MineralsApp';
import { MineralsApp2 } from './components/MineralsApp2';
import { NivieApp } from './components/NivieApp';
import { Adv1v2App } from './components/Adv1v2App';
import { Adv2App } from './components/Adv2App';
import { Adv3App } from './components/Adv3App';
import { Adv3v2App } from './components/Adv3v2App';
import { Adv4App } from './components/Adv4App';
import { Adv5App } from './components/Adv5App';
import { Adv6App } from './components/Adv6App';
import { Adv7App } from './components/Adv7App';
import { Adv8App } from './components/Adv8App';
export function AppRouter() {
  return <HelmetProvider data-id="element-2">
      <BrowserRouter data-id="element-3">
        <Routes data-id="element-4">
          <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
          <Route path="/adv-1" element={<App data-id="element-8" />} data-id="element-7" />
          <Route path="/adv-1v2" element={<Adv1v2App data-id="element-10" />} data-id="element-9" />
          <Route path="/adv-2" element={<Adv2App data-id="element-12" />} data-id="element-11" />
          <Route path="/adv-3" element={<Adv3App data-id="element-14" />} data-id="element-13" />
          <Route path="/adv-3v2" element={<Adv3v2App data-id="element-16" />} data-id="element-15" />
          <Route path="/adv-4" element={<Adv4App data-id="element-18" />} data-id="element-17" />
          <Route path="/adv-5" element={<Adv5App data-id="element-20" />} data-id="element-19" />
          <Route path="/adv-6" element={<Adv6App data-id="element-22" />} data-id="element-21" />
          <Route path="/adv-7" element={<Adv7App data-id="element-24" />} data-id="element-23" />
          <Route path="/adv-8" element={<Adv8App data-id="element-26" />} data-id="element-25" />
          <Route path="/minerals-adv-1" element={<MineralsApp data-id="element-28" />} data-id="element-27" />
          <Route path="/minerals-adv-2" element={<MineralsApp2 data-id="element-30" />} data-id="element-29" />
          <Route path="/is-nivie-organics-drops-legit" element={<NivieApp data-id="element-32" />} data-id="element-31" />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>;
}